// Service client : même numéro que l'application Qovoltis, pour l'appel comme pour WhatsApp.
export const SUPPORT_PHONE = "+33974340340";

const WHATSAPP_NUMBER = SUPPORT_PHONE.replace(/\D/g, "");

// Lien wa.me prérempli avec la borne, la prise, la transaction quand elle existe,
// et l'heure : le service client retrouve la session sans avoir à poser de questions.
export const buildSupportWhatsAppUrl = (t, { station, connector, transaction, date = new Date() }) => {
  const time = date.toLocaleString(undefined, {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
  const text = t(transaction ? "support.whatsappMessageTransaction" : "support.whatsappMessage", {
    station: station || "-",
    connector: connector || "-",
    transaction,
    time,
  });

  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
};

export const SUPPORT_PHONE_URL = `tel:${SUPPORT_PHONE}`;
